import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { stopEndpointSubdiv, launchEndpointSubdiv } from './actions';

export interface EndpointOperationSubdivState {
  loaded: boolean;
  success: boolean;
  message: string;
}

const initialState: EndpointOperationSubdivState = {
  loaded: false,
  success: false,
  message: ''
};

const reducer = reducerWithInitialState(initialState)
  .case(launchEndpointSubdiv.started, (state) => {
    return { ...state, loaded: false, success: false, message: ''};
  })
  .case(launchEndpointSubdiv.done, (state, param) => {
    return { ...state, loaded: true, success: param.result.success, message: param.result.message};
  })
  .case(launchEndpointSubdiv.failed, (state, error) => {
    console.log('reducer async failed error', error);
    return { ...state };
  })
  .case(stopEndpointSubdiv.started, (state) => {
    return { ...state, loaded: false, success: false, message: ''};
  })
  .case(stopEndpointSubdiv.done, (state, param) => {
    return { ...state, loaded: true, success: param.result.success, message: param.result.message};
  })
  .case(stopEndpointSubdiv.failed, (state, error) => {
    console.log('reducer async failed error', error);
    return { ...state };
  })
;

export default reducer;


// WEBPACK FOOTER //
// ./src/redux/modules/endpointOperationSubdiv/reducers.ts